import styled from 'styled-components';
import { Common, color, device } from '@stockbit/ui';
import { Wrapper } from '../styled';

const { Flex, Text } = Common;

const SectionWrapper = styled(Wrapper)`
  align-items: center;

  @media ${device.laptop} {
    align-items: flex-start;
    flex-direction: row;
  }
`;

const TitleWrapper = styled(Flex).attrs({
  direction: 'column',
})`
  align-items: center;
  margin-bottom: 30px;
  text-align: center;
  width: 100%;

  @media ${device.laptop} {
    align-items: flex-start;
    margin-bottom: 0;
    text-align: left;
    width: calc((100% - 201px) / 3);
  }
`;

const Title = styled(Text).attrs({
  as: 'h3',
  family: 'bold',
  size: '40px',
  mb: '10px',
  height: 1.2,
})`
  text-align: inherit;
`;

const Description = styled(Flex).attrs({
  as: 'a',
  align: 'center',
  wrap: 'wrap',
})`
  background: no-repeat center right / 16px auto;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAG2SURBVGhD7Zi/LwRREMcHodAo0BGNQohEoqBQEYma+AMUNm7eXaGQiMKV/AEKEqUf2XmH5HqNSqGi1BCdSkIkkuPM25uTW3ul4ibmk0wut+9bzCf73tt9C4ZhGIZhGMY/4jjqg2KxXf4ppApt4J3nqoLHRyCckBFlEM7UJOqFzxDjsIwqIi6MArmvlAy5BzgrDEhCEbHbTokkhbcs2S8JRRDuZWTIXUM56paEEmqL/igj4/ESqNglKSWEhsmVszK8q9Fyh6SUEKYS4VUTmf3krqmCop5ksWdldiTRhHPXC5SbbLmKcYEbf/klUuXrG9J5Ax7XuT4z4Vau8MwhtyIGTG2XyBrrqAo/e+bFhCF31ySkoe7TD8tSfoRlYh64adF65UpLED7BaW5QDBRQckvceCUtwi+UHsckoYA4P8sNf6Qlwt3BKUkoIDTr8S0twVJBTg2xG+emefo0SoTplVuUhAJKOJQs5EaJ5JyCq5JQQNhKw5baKJGI4KYkFBA+OIRzR1ZiVxJKOFubzkh4PNT3phvO5h7ffyQIL/SdPep4nOPpdcK/W3AQdcpVwzAMwzAMw/gLAL4BSNemrTyIDIIAAAAASUVORK5CYII=');
  color: ${color.primary};
  font-size: 14px;
  margin-bottom: 15px;
  padding-right: 30px;

  b {
    font-family: var(--bold-font);
  }

  &:hover {
    color: ${color.primary};
  }
`;

const FeaturesWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 30px;
  width: 100%;

  @media ${device.tablet} {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 60px;
  }

  @media ${device.laptop} {
    margin-left: 100px;
    width: calc(2 * ((100% - 101px) / 3));
  }
`;

const FeatureItemWrapper = styled(Flex).attrs({
  direction: 'column',
})`
  align-items: center;
  text-align: center;
  width: 100%;

  @media ${device.laptop} {
    align-items: flex-start;
    text-align: left;
  }
`;

const FeatureItemTitle = styled(Text).attrs({
  family: 'bold',
  as: 'h4',
})`
  font-size: 17px;
  margin-bottom: 10px;

  @media ${device.tablet} {
    font-size: 19px;
  }
`;

const FeatureDescription = styled(Text).attrs({
  color: color.dimgray,
  size: '16px',
  height: 1.3,
})`
  text-align: inherit;
`;

export {
  SectionWrapper,
  FeaturesWrapper,
  FeatureItemWrapper,
  FeatureItemTitle,
  FeatureDescription,
  TitleWrapper,
  Title,
  Description,
};
